import { NotificationBox, NotificationContent } from '@components/_Revamp/NotificationBox'
import React from 'react'

export interface PaymentMessageBoxProps {
  children: React.ReactNode;
  rowGap?: string;
}

function PaymentMessageBox({ children, rowGap }: PaymentMessageBoxProps) {

  return (
    <NotificationBox margin={"0 0 48px 0"}>
      <NotificationContent rowGap={rowGap}>
        {children}
      </NotificationContent>
    </NotificationBox>
  )
}

export default PaymentMessageBox